import { GXL_ENVIRONMENT } from "@/features/config";

const BETTERSTACK_TOKEN = "TbmULHihGMiJJWpSfbENB5v6";

/** Better Stack docs use `production` / `staging`; our app uses `prod` / `staging` / `dev`. */
const BETTERSTACK_ENVIRONMENT: Record<string, string> = {
  prod: "production",
  staging: "staging",
  dev: "development",
};

export type BetterStackUser = {
  id: string;
  plan?: string;
};

const hasBetterStack = () => typeof window !== "undefined" && typeof window.betterstack === "function";

/** Associate the session with a signed-in user (queued until b.js loads). */
export const identifyBetterStackUser = (user: BetterStackUser) => {
  if (!hasBetterStack()) return;
  window.betterstack("user", user);
};

/** Clear the Better Stack user association on sign-out. */
export const clearBetterStackUser = () => {
  if (!hasBetterStack()) return;
  window.betterstack("user", null);
};

/** Send a custom product event (queued until b.js loads). */
export const trackBetterStackEvent = (name: string, data?: Record<string, unknown>) => {
  if (!hasBetterStack()) return;
  window.betterstack("track", name, data ?? {});
};

const initBetterStack = () => {
  const environment =
    BETTERSTACK_ENVIRONMENT[GXL_ENVIRONMENT ?? ""] ?? GXL_ENVIRONMENT ?? "development";

  const stub = (...args: unknown[]) => {
    (stub.q = stub.q || []).push(args);
  };
  stub.q = [] as unknown[][];
  stub.l = +new Date();
  window.betterstack = stub;

  const script = document.createElement("script");
  script.async = true;
  script.crossOrigin = "anonymous";
  script.src = `https://betterstack.net/b.js?t=${BETTERSTACK_TOKEN}`;
  document.head.appendChild(script);

  window.betterstack("init", { environment });
};

if (typeof window !== "undefined") {
  initBetterStack();
}
